import SystemNotification from './systemNotification';
import { OP_WRAPPER_LOCALIZATION_PREFIX } from '../../../../utils/constants';

export default class WinLimitNotification extends SystemNotification {
  constructor(...data) {
    super(...data);

    this._eButtonsTypes = {
      ...this._eButtonsTypes,
      EBT_BUTTON_OK: 'button_ok'
    }

    this._eButtonsActions = {
      ...this._eButtonsActions,
      [this._eButtonsTypes.EBT_BUTTON_OK]: () => {
        this.kill();
      }
    }

    this._eElementsTypes = {
      ...this._eElementsTypes,
      EET_BODY: 'body',
      EET_BUTTON_OK: this._eButtonsTypes.EBT_BUTTON_OK
    }

    this._localizations = {
      ...this._localizations,
      [this._eElementsTypes.EET_BUTTON_OK]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.notifications.ok`
    };

    this._buttonShown = false;
  }

  _afterInit() {
    super._afterInit();
    this._localizationValues = {
      [this._eElementsTypes.EET_MESSAGE]: { $limit: this._moneyFormat(this._data.winLimit) },
    };
    this._updateLocalizations();
  }

  _trackLifeTime(timestamp) {
    if (this._startTimestamp && timestamp - this._startTimestamp >= 10000 && !this._buttonShown) {
      this.interactiveElements[this._eElementsTypes.EET_BODY].classList.add('can_be_closed');
      this._buttonShown = true;
    }

    super._trackLifeTime(timestamp);
  }

  _getMarkup() {
    return `<div id=${this.interactiveElementsIds[this._eElementsTypes.EET_CONTAINER_ROOT]} class="OPWrapper_service__notifications__wrapper__container">
              <div class="OPWrapper_service__notifications__wrapper__notification">
                <div id=${this.interactiveElementsIds[this._eElementsTypes.EET_BODY]} class="system-ui-container__notifications__system_notification system-ui-container__notifications__win_limit_notification">
                  <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_MESSAGE]}>${this._getLocalization(this._localizations[this._eElementsTypes.EET_MESSAGE])}</span>
                  <div class="system-ui-container__notifications__win_limit_notification__button_wrapper">
                    <div>
                      <button id=${this.interactiveElementsIds[this._eElementsTypes.EET_BUTTON_OK]} data-color="system_submit">${this._getLocalization(this._localizations[this._eElementsTypes.EET_BUTTON_OK])}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>`
  }
}
